import { isEmpty } from 'underscore';
import { CampaignType, convertFilteredCampaignTypeToFilter } from '@bingads-webui-campaign/campaign-ui-common';
import { FilterStorageFactory, WaterfallFilterType, WaterfallFilterStorage } from '@bingads-webui-campaign/filter-storage';

// get waterfall filter store
function getWaterfallFilterStore({ preferenceService }) {
  return new WaterfallFilterStorage({
    preferenceService,
  });
}

// get campaign filter store
function getCampaignFilterStore({ preferenceService }) {
  const campaignFilterFactory = new FilterStorageFactory({
    preferenceService,
    featureName: 'CampaignsGrid',
  });
  const campaignFilterStore = campaignFilterFactory.create('editableFilter', {
    filterEntityOptions: {
      entitySchema: { name: 'Campaign' },
    },
  });
  return campaignFilterStore;
}

// get filter store preferences
function getFilterStorePreferences({ preferenceService, filterStore, featureName }) {
  return preferenceService.findByName(filterStore.getStorageKey(featureName));
}

// get query for campaign filter
function getCampaignFilterQuery({ campaignFilterType }) {
  let filterQuery = {};

  if (campaignFilterType === 'pmax') {
    // pmax campaign type filter
    filterQuery = {
      CampaignType: {
        $in: ['Enum.CampaignType\'PerformanceMax\''],
      },
      name: null,
      id: null,
    };
  }

  return filterQuery;
}

// reset campaign filter and redirect through callback
export async function resetCampaignFiltersAndRedirect({
  preferenceService, campaignFilterType, callback,
}) {
  const waterfallFilterStore = getWaterfallFilterStore({ preferenceService }); // waterfall filter store
  const campaignFilterStore = getCampaignFilterStore({ preferenceService }); // campaign filter store
  const waterfallFilterPreferences = getFilterStorePreferences({ // waterfall filter preferences
    preferenceService,
    filterStore: waterfallFilterStore.waterfallFilterStorages[WaterfallFilterType.CampaignType],
    featureName: waterfallFilterStore.waterfallFilterStorages[WaterfallFilterType.CampaignType].featureName,
  });
  const campaignFilterPreferences = getFilterStorePreferences({ // campaign filter preferences
    preferenceService,
    filterStore: campaignFilterStore,
    featureName: { featureName: campaignFilterStore.permanentFilterStorage.featureName },
  });

  // set campaign type to all campaigns in waterfall filters
  // if the current campaign type is the same one, no update based on waterfall filter existing logic
  waterfallFilterStore.save(WaterfallFilterType.CampaignType, convertFilteredCampaignTypeToFilter(CampaignType.All));

  // set campaign type to campaignFilterType in campaign filter
  const campaignFilterQuery = getCampaignFilterQuery({ campaignFilterType }); // campaign filter query
  campaignFilterStore.save(!isEmpty(campaignFilterQuery) ? { query: campaignFilterQuery } : {});

  // must wait for the remote sync done to get the correct preferences
  const idList = []
    .concat((waterfallFilterPreferences && waterfallFilterPreferences.Id) || [])
    .concat((campaignFilterPreferences && campaignFilterPreferences.Id) || []);
  await preferenceService.onMultipleRemoteSyncDone(idList).then(() => {
    callback();
  });
}
